import { IconButton, TableCell, TableRow, Tooltip, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function GroupRow({ group, onDelete }) {
    return (
        <TableRow hover>
            <TableCell>{group.displayName}</TableCell>
            <TableCell sx={{ fontFamily: "monospace", fontSize: 12, color: "text.secondary" }}>
                {group.externalId || (
                    <Typography variant="caption" color="text.disabled">
                        none
                    </Typography>
                )}
            </TableCell>
            <TableCell align="center">{group.memberCount ?? 0}</TableCell>
            <TableCell align="right">
                <Tooltip title="Delete group">
                    <IconButton size="small" color="error" onClick={handleDelete}>
                        <Iconify icon="mdi:delete-outline" width={18} />
                    </IconButton>
                </Tooltip>
            </TableCell>
        </TableRow>
    )

    function handleDelete() {
        onDelete?.(group)
    }
}
